// extracted by mini-css-extract-plugin
export default {"overlayContent":"overlay_overlayContent__tgxVF","closer":"overlay_closer__P3HF5","overlay":"overlay_overlay__n3w44","hpiStyle":"overlay_hpiStyle__5-01t"};